import { Link } from "react-router-dom";
import type { Character } from "@/utils/content";

export default function CharacterCard({ character }: { character: Character }) {
  return (
    <Link
      to={`/character/${character.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative h-48 w-full overflow-hidden bg-background-200">
        <img
          src={character.avatar}
          alt={`${character.name} 角色立绘`}
          title={`火影忍者角色 ${character.name}`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute right-3 top-3 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-bold text-background-50">
          {character.category}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
          {character.name}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">{character.epithet}</p>
        <p className="mt-2.5 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {character.intro}
        </p>
      </div>
    </Link>
  );
}